export default __webpack_public_path__ + "static/media/coin_r.cc852c58.png";